// extracted by mini-css-extract-plugin
module.exports = {"alert":"v9OoabdOs7lTMC4hxbVI","partnerSelect":"aOqWu_uVp0goQdPWWQzI","tldr":"VMbpoa7_tgvfh267OuwH"};